import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/noviceGuide/logo-half-top.png'


const _withScopeId = n => (_pushScopeId("data-v-412882f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  class: "Popover-bottom",
  style: {"margin-bottom":"20px"}
}
const _hoisted_3 = { class: "Popover-bottom-skip" }
const _hoisted_4 = { class: "Popover-bottom-next" }

import { onMounted, nextTick, reactive } from 'vue'
import { t } from '@/plugins/i18n'
import { isD2C } from '@/store'
import { ElButton } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: {
  // 内容
  description: {
    type: String,
    default: ''
  },
  // 位置
  position: {
    type: String,
    default: 'bottom-right'
  },
  // 弹窗气泡宽度
  popoverWidth: {
    type: Number,
    default: 500
  },
  // X轴偏移量
  offsetX: {
    type: Number,
    default: 0
  },
  // Y轴偏移量
  offsetY: {
    type: Number,
    default: 0
  },
  // 当前step
  curStep: {
    type: Number,
    default: 0
  },
  // 总step
  totalStep: {
    type: Number,
    default: 0
  },
  // 是否可以跳过
  isSkip: {
    type: Boolean,
    default: true
  },
  // 青蛙宽度
  iconWidth: {
    type: String,
    default: '72'
  },
  // 弹窗left
  modalLeft: {
    type: Number,
    default: 0
  },
  modalTop: {
    type: Number,
    default: 0
  }
},
  emits: ['next', 'skip'],
  setup(__props, { emit: emits }) {

const props = __props


onMounted(() => {
  nextTick(() => {
    const dom: any = document.querySelector('.NoviceGuide-Popover')
    const domSize: any = dom?.getBoundingClientRect()
    data.width = domSize.width
    data.height = domSize.height
    const parentDom: any = document.querySelector('.LocalHighlight-main')?.getBoundingClientRect()
    data.parentWidth = parentDom.width
    data.parentHeight = parentDom.height
    const iconDom: any = document.querySelector('.Popover-frog')
    setStyle(dom, iconDom)
  })
})

// icon宽高比
const iconRatio = 0.6712328767123288


const data = reactive({
  width: 0,
  height: 0,
  parentWidth: 0,
  parentHeight: 0
})

// const styleList: any = computed(() => {
//   if (props.position === 'mid') {
//     return []
//   } else {
//     const position = props.position.split('-')[0]
//     const direction = props.position.split('-')[1]
//     const styleList = []
//     if (position === 'top') {
//       styleList.push({ top: 0 })
//       styleList.push({ marginTop: `-${data.height}px` })
//       if (direction === 'right') {
//         styleList.push({ marginTop: 0 })
//       }
//     }
//     return styleList
//   }
// })

// 根节点和icon插入style
const setStyle = (dom: any, iconDom: any) => {
  if (props.position === 'mid') {
    return false
  } else {
    const position = props.position.split('-')[0]
    const direction = props.position.split('-')[1]
    // const styleList = []
    const styleObj: any = {}
    const offsetIconAside = 20
    const offsetIconHead = 30
    if (position === 'top') {
      styleObj.top = props.modalTop ? props.modalTop + 'px' : 0
      styleObj.left = 0
      styleObj.marginTop = `-${data.height + offsetIconHead}px`
      if (direction === 'right') {
        styleObj.marginLeft = `${data.parentWidth / 2 + offsetIconAside + props.offsetX}px`
      }
      if (direction === 'left') {
        styleObj.marginLeft = `${-data.width + data.parentWidth / 2 - offsetIconAside + props.offsetX}px`
      }
    }
    if (position === 'bottom') {
      styleObj.bottom = '-65px'
      styleObj.left = props.modalLeft ? props.modalLeft + 'px' : 0
      styleObj.marginBottom = `-${data.height + offsetIconHead}px`
      if (direction === 'right') {
        styleObj.marginLeft = `${data.parentWidth / 2 + offsetIconAside + props.offsetX}px`
      }
      if (direction === 'left') {
        styleObj.marginLeft = 0
      }
    }
    if (position === 'left') {
      styleObj.top = 0
      styleObj.left = 0
      styleObj.marginLeft = `-${data.width + offsetIconHead}px`
      if (direction === 'top') {
        styleObj.marginTop = `-${data.height - data.parentHeight / 2 + offsetIconAside - props.offsetY}px`
      }
      if (direction === 'bottom') {
        styleObj.marginTop = `${data.parentHeight / 2 + offsetIconAside + props.offsetY}px`
      }
    }
    if (position === 'right') {
      styleObj.top = 0
      styleObj.right = 0
      styleObj.marginRight = `-${data.width + offsetIconHead}px`
      if (direction === 'top') {
        styleObj.marginTop = `-${data.height - data.parentHeight / 2 + offsetIconAside - props.offsetY}px`
      }
      if (direction === 'bottom') {
        styleObj.marginTop = `${data.parentHeight / 2 + offsetIconAside + props.offsetY}px`
      }
    }
    for (const key in styleObj) {
      dom.style[key] = styleObj[key]
    }
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["Popover NoviceGuide-Popover", [
    _unref(isD2C)() ? 'd2c' : 'b2b'
  ]]),
    style: _normalizeStyle([
  { width: __props.popoverWidth + 'px' }
]),
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", null, [
      (__props.position.split('-')[2] === 'top')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            referrerPolicy: "no-referrer",
            class: "LocalHighlight-main-frog LocalHighlight-main-frog-top",
            style: _normalizeStyle({
        width: `${__props.iconWidth}px`,
        height: `${Number(__props.iconWidth) * iconRatio}px`,
        marginLeft: `${__props.offsetX}px`,
        transform: `translate(${__props.position.split('-')[3]==='right'?'140px':'-250px'}, -100%)`
      }),
            src: _imports_0
          }, null, 4))
        : _createCommentVNode("", true),
      (__props.position.split('-')[2] === 'bottom')
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            referrerPolicy: "no-referrer",
            class: "LocalHighlight-main-frog LocalHighlight-main-frog-bottom",
            style: _normalizeStyle({
          width: `${__props.iconWidth}px`,
          height: `${Number(__props.iconWidth) * iconRatio}px`,
          marginLeft: `${__props.offsetX}px`
        }),
            src: _imports_0
          }, null, 4))
        : _createCommentVNode("", true),
      (__props.position.split('-')[2] === 'right')
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            referrerPolicy: "no-referrer",
            class: "LocalHighlight-main-frog LocalHighlight-main-frog-right",
            style: _normalizeStyle({
          width: `${Number(__props.iconWidth) * iconRatio}px`,
          height: `${__props.iconWidth}px`,
          marginTop: `${__props.offsetY}px`
        }),
            src: _imports_0
          }, null, 4))
        : _createCommentVNode("", true),
      (__props.position.split('-')[2] === 'left')
        ? (_openBlock(), _createElementBlock("img", {
            key: 3,
            referrerPolicy: "no-referrer",
            class: "LocalHighlight-main-frog LocalHighlight-main-frog-left",
            style: _normalizeStyle({
          width: `${Number(__props.iconWidth) * iconRatio}px`,
          height: `${__props.iconWidth}px`,
          marginTop: `${__props.offsetY}px`
        }),
            src: _imports_0
          }, null, 4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "Popover-content",
      innerHTML: __props.description
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.isSkip)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              class: "btn",
              type: "text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('skip')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('跳过')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("div", { class: "progress" }, _toDisplayString(`(${__props.curStep + 1}/${__props.totalStep})`), 513), [
          [_vShow, __props.totalStep > 1]
        ]),
        (__props.curStep + 1 !== __props.totalStep)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              class: "btn",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emits('next')), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('下一步')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.curStep + 1 === __props.totalStep)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 1,
              class: "btn",
              type: "primary",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (emits('skip')), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('我知道了')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["Popover-tip", 'Popover-tip-' + __props.position.split('-')[0]])
    }, null, 2)
  ], 6))
}
}

})